import { PageWrapper, SuiTable } from '@britishcouncil/react-admin';

import { CentreTypeSelector, DisciplinaryActionDueReportRecordDto } from 'api';
import { useTableState } from 'hooks';
import { TableState } from 'types';
import {
  DisciplinaryActionDueReportFilterType,
  useGetDisciplinaryActionDueRecordsQuery,
  useGenerateDisciplinaryActionDuePdfReportMutation,
  useGenerateDisciplinaryActionDueExcelReportMutation,
} from 'store';
import { ReportExportButton } from '../common';
import { columns } from './DisciplinaryActionDueReportColumns';
import { DisciplinaryActionDueReportFiltersBar } from './DisciplinaryActionDueReportFilters';

export const DisciplinaryActionDueReport = () => {
  const { tableState, setTableState, setFilterState } = useTableState(initialTableState);
  const { filters, ...pagingAndSortingState } = tableState;

  const { data, isFetching } = useGetDisciplinaryActionDueRecordsQuery(tableState, {
    skip: !filters.date?.[0] || !filters.date?.[1],
  });

  const [generatePdf, { isLoading: isPdfLoading }] =
    useGenerateDisciplinaryActionDuePdfReportMutation();
  const [generateExcel, { isLoading: isExcelLoading }] =
    useGenerateDisciplinaryActionDueExcelReportMutation();

  return (
    <PageWrapper
      mainActions={
        <ReportExportButton
          disabled={data?.results === undefined || data.totalCount === 0}
          fileName="DisciplinaryActionDue"
          generatePdf={() => generatePdf(tableState)}
          isPdfLoading={isPdfLoading}
          generateExcel={() => generateExcel(tableState)}
          isExcelLoading={isExcelLoading}
        />
      }
      mainActionsAbove
    >
      <DisciplinaryActionDueReportFiltersBar
        setFilterState={setFilterState}
        initialFilterState={initialTableState.filters}
      />
      <SuiTable
        columns={columns}
        data={data?.results ?? []}
        disableFilters
        onStateChange={setTableState}
        loading={isFetching}
        state={pagingAndSortingState}
        totalCount={data?.totalCount}
        cellWhiteSpace="normal"
      />
    </PageWrapper>
  );
};

const initialTableState: TableState<
  DisciplinaryActionDueReportRecordDto,
  DisciplinaryActionDueReportFilterType
> = {
  pageIndex: 0,
  pageSize: 20,
  sortBy: [],
  filters: {
    centreType: CentreTypeSelector.ALL,
  },
};
